import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export function ErrorFallback({ resetError }: { resetError?: () => void }) {
  return (
    <div className="min-h-[400px] flex flex-col items-center justify-center gap-4 p-8 text-center">
      <AlertCircle className="h-12 w-12 text-destructive" />
      <div>
        <h2 className="text-xl font-semibold mb-1">Something went wrong</h2>
        <p className="text-sm text-muted-foreground max-w-md">
          We've been notified and are looking into it. Try refreshing, or head back to the dashboard.
        </p>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => window.location.reload()}>Refresh</Button>
        {resetError && <Button onClick={resetError}>Try again</Button>}
      </div>
    </div>
  );
}
